<template>
  <div>
    <div class="card mb-2">
      <div class="card-header bg-primary text-white font-weight-bold">
        My Pending Reviews
      </div>
        <LoadingSpinner v-if="loading" message="" size='1x' />
        <p v-else-if="!entities || entities.length === 0">
        No Reviews are currently assigned to you
        </p>
        <template v-else>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">
                  <span class='search-result-header'>Item ID</span>
                </th>
                <th scope="col">
                  <span class='search-result-header'>Assigned By</span>
                </th>
                <th scope="col">
                  <span class='search-result-header'>Project ID</span>
                </th>
                <th scope="col">
                  <span class='search-result-header'>Open Date</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="review in visibleReviews">
                <tr
                  v-bind:key="review.id"
                  class="list-table-text">
                  <td :id="'review-inst' + review.id">
                    <router-link
                      :to="{ name: `project${checkParentType(review)}`, params: {
                      project_id: review.primaryProjectId,
                      id: review.parentId}}"
                      class="view-link"
                      >
                      {{ formatIdString(review) }}
                    </router-link>
                    <b-tooltip :target="'review-inst' + review.id">
                      {{review.instructions === null ? 'No instructions provided' : review.instructions}}
                    </b-Tooltip>
                  </td>
                  <td>
                    {{ review.assignerName || 'None' }}
                  </td>
                  <td :id="'review-proj' + review.id">
                    {{ review.primaryProjectId }}
                    <b-tooltip :target="'review-proj' + review.id">
                      {{review.projectName === null ? 'N/A' : review.projectName}}
                    </b-Tooltip>
                  </td>
                  <td>
                    {{ review.openDate | dateString }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </template>
    </div>
    <PaginationControls
      :orderedEntities="entities"
      :initialPageSize="initialPageSize"
      :pageSize="pageSize"
      :pageSizeOptions="pageSizeOptions"
      :currentPage="currentPage"
      :firstVisibleEntry="firstVisibleEntry"
      :lastVisibleEntry="lastVisibleEntry"
      :rows="rows"
      @update-current-page="updateCurrentPage"
      @update-page-size="updatePageSize">
    </PaginationControls>
  </div>
</template>

<script>
import moment from 'moment';
import { LookupModules } from '@/store/moduleConfig';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import Pagination from '@/mixins/Pagination';
import PaginationControls from '@/components/common/PaginationControls.vue';

export default {
  name: 'MyReviews',
  components: {
    LoadingSpinner,
    PaginationControls,
  },
  props: {
    entities: Array,
    entityName: String,
    loading: Boolean,
    selectedType: String,
    formatIdString: Function,
  },
  data() {
    return {
      pageSize: 100,
      currentPage: 1,
    };
  },
  mixins: [Pagination],
  mounted() {
    // dispatch actions to populate vuex state for this page
    this.$store.dispatch(`${LookupModules.SERVICE_CATEGORIES.namespace}/fetchOptions`,
      LookupModules.SERVICE_CATEGORIES.url);
  },
  computed: {
    rows() {
      return !this.entities ? 0 : this.entities.length;
    },
    visibleReviews() {
      // sort descending by openDate and ascending by serviceId
      return this.entities
        .slice(0)
        .sort((a, b) => moment(a.openDate).format('YYYYMMDD')
          - moment(b.openDate).format('YYYYMMDD')
          || a.parentId - b.parentId)
        .slice(
          ((this.currentPage - 1) * this.pageSize),
          (this.currentPage * this.pageSize),
        );
    },
  },
  methods: {
    checkParentType(review) {
      if (review.instrumentId) {
        return 'Instrument';
      }
      return 'Service';
    },
  },
};
</script>
